// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"1e26b5a0","196":"8ec0cb89","256":"ec26a1db","330":"e8b5262f","488":"7b289125","534":"e88dfb6c","701":"d21e4c42","753":"b1b103e4"}[chunkId] + ".chunk.js";
};